import {connect} from "react-redux";
import PennyDropAccount from "./PennyDropAccount";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../services/redux/fileUpload/action";
import {loanAccountRequest, accountPennyDropRequest} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    loanAccountResponse: state.CarLoan.loanAccountResponse,
    accountPennyDropResponse: state.CarLoan.accountPennyDropResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            loanAccountRequest,
            accountPennyDropRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PennyDropAccount);
